import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useAppContext } from 'providers/AppProvider';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import moment from 'moment';
import { postJobTable } from 'nursd-dashboard/api/jobTable';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';
// import FalconReactRange from 'components/doc-components/FalconReactRange';
import {
  duration,
  jobTypes,
  licenseTypes
} from 'nursd-dashboard/data/defaultData';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { getNurseAvaJobDate } from 'nursd-dashboard/api/nurseTable';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

const AddScheduleModal = ({
  setIsOpenScheduleModal,
  isOpenScheduleModal,
  scheduleStartDate,
  setScheduleStartDate,
  scheduleEndDate,
  setScheduleEndDate,
  managers,
  customers,
  nurse,
  authToken,
  location,
  organization,
  refresh,
  setRefresh
}) => {
  const {
    config: { isDark }
  } = useAppContext();

  const searchInput = useRef(null);

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const type = 'Shift';

  const animatedComponents = makeAnimated();

  const [loading, setLoading] = useState(false);
  const [valueDuration, setValueDuration] = useState(null);
  const [valueLicense, setValueLicense] = useState(null);
  const [valueManager, setValueManager] = useState(null);
  const [valueCustomer, setValueCustomer] = useState(null);
  const [valueJobTypes, setValueJobTypes] = useState({
    value: '1',
    label: 'Shift'
  });

  // const [type, settType] = useState('Shift');
  // const [duration, setDuration] = useState([1]);

  const [formData, setFormData] = useState({
    shiftTitle: '',
    startDate: new Date(),
    endDate: new Date(),
    break: 'No Break',
    customerName: null,
    customerId: '',
    unit: '',
    floor: '',
    fullAddress: '',
    latitude: '',
    longitude: '',
    notes: '',
    jobType: type,
    jobTiming: '',
    customerVisibility: false,
    autoAccept: false,
    baseRate: '',
    baseRateEnable: false,
    jobPostingTableFacilityTableId: '',
    jobPostingTableFacilityTableName: ''
  });

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  function timeDifferent(sTime, eTime) {
    const startTime = moment(
      moment(new Date(sTime)).format('hh:mma'),
      'hh:mm A'
    );

    const start = moment(new Date(sTime));
    const end = moment(new Date(eTime));

    const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
    const endTimeEnd = moment(
      moment(new Date(eTime)).format('hh:mma'),
      'hh:mm A'
    ).add(1, 'day');

    const duration = moment.duration(endTime.diff(startTime));
    const durationEnd = moment.duration(endTimeEnd.diff(startTime));

    const hours = Math.floor(duration.asHours());
    const hoursEnd = Math.floor(durationEnd.asHours());
    const minutes = Math.floor(duration.asMinutes()) - hours * 60;

    // const onlyHours = `${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours
    //     : end.hour() <= 12
    //     ? hoursEnd
    //     : hours
    // } ${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours <= 1
    //       ? "hour"
    //       : "hours"
    //     : end.hour() <= 12
    //     ? hoursEnd <= 1
    //       ? "hour"
    //       : "hours"
    //     : hours <= 1
    //     ? "hour"
    //     : "hours"
    // }`;

    const onlyHours = `${
      end.hour() <= 12 && start.hour() <= 12
        ? hours
        : end.hour() <= 12
        ? hoursEnd
        : hours
    }${hours <= 1 ? 'hour' : 'hours'} ${
      minutes <= 0 ? '' : `${minutes}minutes`
    }`;

    return onlyHours;
  }

  const handleClose = () => {
    setIsOpenScheduleModal(!isOpenScheduleModal);
    setScheduleStartDate(null);
    setScheduleEndDate(null);
    setValueLicense(null);
    setValueManager(null);
    setValueCustomer(null);
    // setDuration([1]);
    setValueJobTypes({
      value: '1',
      label: 'Shift'
    });
    setFormData({
      shiftTitle: '',
      startDate: new Date(),
      endDate: new Date(),
      break: 'No Break',
      customerName: null,
      customerId: '',
      unit: '',
      floor: '',
      fullAddress: '',
      latitude: '',
      longitude: '',
      notes: '',
      jobType: type,
      jobTiming: '',
      autoAccept: false,
      customerVisibility: false,
      baseRate: '',
      baseRateEnable: false,
      jobPostingTableFacilityTableId: '',
      jobPostingTableFacilityTableName: ''
    });
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value =
      name === 'customerVisibility'
        ? target.checked
        : name === 'baseRateEnable'
        ? target.checked
        : name === 'autoAccept'
        ? target.checked
        : target.value;
    setFormData({ ...formData, [name]: value });
  };

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleChange({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleChange({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleChange({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  const notification = async () => {
    if (nurse?.mobileId) {
      sendNotification(authToken, {
        expoPushToken: nurse?.mobileId,
        title: `“Direct ${valueJobTypes?.label}s Assignment” (Check Upcoming Jobs)`,
        body: `${valueJobTypes?.label} assigned.`,
        data: { screen: 'HomeScreen' }
      });
    }
    await postNurseNotification(
      authToken,
      nurse?.id,
      '',
      `“Direct ${valueJobTypes?.label}s Assignment” (Check Upcoming Jobs)`,
      `${valueJobTypes?.label}s assigned.`,
      'HomeScreen',
      {
        screen: 'UpComing'
      },
      false,
      false,
      'green',
      ''
    );
  };

  const postJob = async () => {
    const ct = new Date(
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString()
    );
    const currentHour = ct.getHours();
    let jobTiming =
      currentHour >= 5 && currentHour < 12
        ? 'Morning'
        : currentHour >= 12 && currentHour < 17
        ? 'Afternoon'
        : currentHour >= 17 && currentHour < 20
        ? 'Evening'
        : 'Night';

    await postJobTable(
      authToken,
      valueLicense?.map(i => i?.label),
      formData?.shiftTitle,
      '',
      [],
      '',
      '0',
      moment(formData?.startDate).format('YYYY-MM-DD'),
      moment(formData?.endDate).format('YYYY-MM-DD'),
      GetDateMergedTime(
        formData?.startDate,
        formData?.startDate?.toString()
      ).toString(),
      GetDateMergedTime(
        formData?.endDate,
        formData?.endDate?.toString()
      ).toString(),
      formData?.break,
      formData?.customerName,
      formData?.customerId?.toString(),
      formData?.unit,
      formData?.floor,
      formData?.fullAddress,
      formData?.latitude?.toString(),
      formData?.longitude?.toString(),
      '1',
      false,
      formData?.notes,
      valueJobTypes?.label,
      'Nurse Assigned',
      nurse?.id?.toString(),
      '',
      [nurse?.id],
      [
        {
          id: nurse?.id,
          type: 'Internal Pool'
        }
      ],
      formData?.autoAccept,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      timeDifferent(formData?.startDate, formData?.endDate),
      jobTiming,
      '',
      [],
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      false,
      false,
      false,
      false,
      false,
      formData.customerVisibility,
      '',
      '',
      {},
      '',
      formData.jobPostingTableFacilityTableId?.toString(),
      false,
      '',
      formData.jobPostingTableFacilityTableId?.toString(),
      '',
      false,
      false,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      GetDateMergedTime(formData?.startDate, formData.startDate?.toString())
        .valueOf()
        .toString(),
      '',
      '',
      '',
      '',
      organization,
      location
    )
      .then(item => {
        notification();
        setValueLicense(null);
        setValueManager(null);
        setValueCustomer(null);
        // setDuration([1]);
        setLoading(false);
        setValueJobTypes({
          value: '1',
          label: 'Shift'
        });
        setFormData({
          shiftTitle: '',
          startDate: new Date(),
          endDate: new Date(),
          break: 'No Break',
          customerName: null,
          customerId: '',
          unit: '',
          floor: '',
          fullAddress: '',
          latitude: '',
          longitude: '',
          notes: '',
          jobType: type,
          jobTiming: '',
          customerVisibility: false,
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: ''
        });
        toast.success(item?.shiftTitle + ' created successfully.', {
          theme: 'colored'
        });
        setIsOpenScheduleModal(false);
        setRefresh(!refresh);
      })
      .catch(error => {
        console.log('data save error:', error);
      });
  };

  const publish = async () => {
    setLoading(true);
    const res = await getNurseAvaJobDate(
      authToken,
      Number(nurse?.id),
      nurse?.uniqueId,
      moment(formData?.startDate).format('YYYY-MM-DD'),
      moment(formData?.endDate).format('YYYY-MM-DD'),
      moment(formData?.startDate).format('hh:mm a'),
      moment(formData?.endDate).format('hh:mm a')
    );
    if (res?.availableTime) {
      postJob();
      setLoading(false);
    } else {
      toast.error(`Date Conflict.Choose a different date.`, {
        theme: 'colored'
      });
      setLoading(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    publish();
  };

  useEffect(() => {
    if (valueJobTypes?.label !== 'Visit') {
      if (scheduleStartDate) {
        setFormData({
          ...formData,
          startDate: scheduleStartDate,
          endDate: scheduleEndDate
        });
      } else {
        setFormData({
          ...formData,
          startDate: new Date(),
          endDate: new Date()
        });
        setScheduleStartDate(new Date());
        setScheduleEndDate(new Date());
      }
    }
  }, [isOpenScheduleModal, scheduleStartDate, scheduleEndDate]);

  return (
    <Modal
      size="lg"
      show={isOpenScheduleModal}
      backdrop="static"
      keyboard={false}
      aria-labelledby="example-modal-sizes-title-lg"
      onHide={handleClose}
      contentClassName="border"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title as="h5">Create Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-x1">
          <Row className="mb-2">
            <Form.Group as={Col} md="4" className="mb-2" controlId="JobType">
              <Form.Label className="fs-9">Job Type</Form.Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select..."
                isClearable
                isSearchable
                name="color"
                value={valueJobTypes}
                onChange={value => {
                  setValueJobTypes(
                    value
                      ? value
                      : {
                          value: '1',
                          label: 'Shift'
                        }
                  );
                }}
                options={jobTypes}
                components={animatedComponents}
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-2" controlId="Manager">
              <Form.Label className="fs-9">Manager</Form.Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select..."
                isClearable
                isSearchable
                name="color"
                value={valueManager}
                onChange={value => {
                  setValueManager(value);
                  setFormData({
                    ...formData,
                    jobPostingTableFacilityTableName: value?.label,
                    jobPostingTableFacilityTableId: value?.id
                  });
                }}
                options={managers}
                components={animatedComponents}
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-2" controlId="License">
              <Form.Label className="fs-9">License</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={licenseTypes}
                placeholder="Select..."
                isMulti
                classNamePrefix="react-select"
                value={valueLicense}
                onChange={value => {
                  setValueLicense(value);
                }}
                components={animatedComponents}
                required
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              md={12}
              className="mb-2"
              controlId="shiftTitle"
            >
              <Form.Label className="fs-9">Title</Form.Label>
              <Form.Control
                type="text"
                name="shiftTitle"
                placeholder="Title"
                required
                value={formData?.shiftTitle}
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
              className="mb-2"
              controlId="startDate"
            >
              <Form.Label className="fs-9">Start</Form.Label>
              <DatePicker
                selected={scheduleStartDate}
                minDate={moment().toDate()}
                onChange={v => {
                  setScheduleStartDate(v);
                  if (valueJobTypes?.label === 'Visit') {
                    let date = moment(new Date(v)).add('hour', 1);
                    // console.log({
                    //   startDate: v,
                    //   endDate: new Date(date)
                    // });
                    setFormData({
                      ...formData,
                      startDate: v,
                      endDate: new Date(date)
                    });
                  } else {
                    // console.log({
                    //   startDate: v
                    // });
                    setFormData({ ...formData, startDate: v, endDate: v });
                  }
                }}
                className="form-control"
                placeholderText="MM-DD-YYYY H:M"
                dateFormat="MM-dd-yyyy h:mm aa"
                showTimeSelect
              />
            </Form.Group>
            {valueJobTypes?.label === 'Shift' && (
              <Form.Group as={Col} md="3" className="mb-2" controlId="Duration">
                <Form.Label className="fs-9">Duration</Form.Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Select..."
                  isClearable
                  isSearchable
                  name="color"
                  value={valueDuration}
                  onChange={value => {
                    setValueDuration(value);

                    let date = new Date();
                    let dateEnd = new Date();
                    let newEnd = new Date(formData.startDate);
                    let selectedHourTime =
                      newEnd.getHours() === 0
                        ? 12
                        : newEnd.getHours() > 12
                        ? newEnd.getHours() - 12
                        : newEnd.getHours();
                    let selectedMinuteTime = newEnd
                      .getMinutes()
                      .toString()
                      .padStart(2, '0');
                    let selectedAPTime = newEnd.getHours() >= 12 ? 'PM' : 'AM';

                    date.setHours(
                      selectedAPTime === 'AM' && selectedHourTime === 12
                        ? 0
                        : selectedAPTime === 'PM' && selectedHourTime === 12
                        ? 12
                        : selectedHourTime !== 12 && selectedAPTime === 'PM'
                        ? parseInt(selectedHourTime) + 12
                        : parseInt(selectedHourTime)
                    );
                    date.setMinutes(selectedMinuteTime);
                    date.setFullYear(newEnd.getFullYear());
                    date.setMonth(newEnd.getMonth());
                    date.setDate(newEnd.getDate());

                    // Add 8 hours to dateEnd based on date
                    dateEnd.setFullYear(date.getFullYear());
                    dateEnd.setMonth(date.getMonth());
                    dateEnd.setDate(date.getDate());
                    dateEnd.setHours(date.getHours() + value?.value);
                    dateEnd.setMinutes(date.getMinutes());

                    // Determine if it's AM or PM
                    let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                    if (selectedAPTime === 'PM' && meridiem === 'AM') {
                      // let endDate = moment(formData.startDate);
                      // endDate.add(1, 'day');
                      setFormData({
                        ...formData,
                        startDate: date,
                        endDate: dateEnd
                      });
                    } else {
                      setFormData({
                        ...formData,
                        startDate: date,
                        endDate: dateEnd
                      });
                    }
                  }}
                  options={duration}
                  components={animatedComponents}
                />
              </Form.Group>
            )}
            <Form.Group
              as={Col}
              md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
              className="mb-2"
              controlId="End"
            >
              <Form.Label className="fs-9">End</Form.Label>
              <Form.Control
                type="text"
                name="End"
                disabled
                value={moment(formData?.endDate).format('MM-DD-YYYY hh:mm A')}
              />
            </Form.Group>
            <Form.Group
              as={Col}
              md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
              className="mb-2"
              controlId="Break"
            >
              <Form.Label className="fs-9">Break</Form.Label>
              <Form.Select
                name="className"
                onChange={event => {
                  const value = event.target.value;
                  let date = new Date(formData.endDate);
                  let dateEnd = new Date(formData.endDate);
                  dateEnd.setFullYear(date.getFullYear());
                  dateEnd.setMonth(date.getMonth());
                  dateEnd.setDate(date.getDate());
                  dateEnd.setHours(
                    value === '1 Hour' ? date.getHours() + 1 : date.getHours()
                  );
                  dateEnd.setMinutes(
                    value === '15 Minutes'
                      ? date.getMinutes() + 15
                      : value === '30 Minutes'
                      ? date.getMinutes() + 30
                      : value === '45 Minutes'
                      ? date.getMinutes() + 45
                      : date.getMinutes()
                  );
                  setFormData({
                    ...formData,
                    break: value,
                    endDate: dateEnd
                  });
                }}
                value={formData?.break}
                required
              >
                <option value="No Break">No Break</option>
                <option value="15 Minutes">15 Minutes</option>
                <option value="30 Minutes">30 Minutes</option>
                <option value="45 Minutes">45 Minutes</option>
                <option value="1 Hour">1 Hour</option>
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md={6} className="mb-2" controlId="Customer">
              <Form.Label className="fs-9">Customer</Form.Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select..."
                isClearable
                isSearchable
                name="color"
                value={valueCustomer}
                onChange={value => {
                  setValueCustomer(value);
                  setFormData({
                    ...formData,
                    customerName: value?.label,
                    customerId: value?.value,
                    fullAddress: value?.address,
                    latitude: value?.latitude,
                    longitude: value?.longitude
                  });
                }}
                options={customers}
                components={animatedComponents}
              />
            </Form.Group>
            <Form.Group
              as={Col}
              md={6}
              className="mb-2"
              controlId="FullAddress"
            >
              <Form.Label className="fs-9">Full Address</Form.Label>
              <Form.Control
                required
                ref={searchInput}
                contentEditable={false}
                type="text"
                placeholder="Full Address"
                value={formData?.fullAddress}
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group as={Col} md="2" className="mb-2" controlId="Unit">
              <Form.Label className="fs-9">Unit</Form.Label>
              <Form.Control
                type="text"
                placeholder="Unit"
                value={formData?.unit}
                name="unit"
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group as={Col} md="2" className="mb-2" controlId="Floor">
              <Form.Label className="fs-9">Floor</Form.Label>
              <Form.Control
                type="text"
                placeholder="Floor"
                name="floor"
                value={formData?.floor}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group
              as={Col}
              md="4"
              className="mb-2 pt-4"
              controlId="customerVisibility"
            >
              <Form.Check
                type="checkbox"
                id="customerVisibility"
                label="Customer Visible After Assignment"
                name="customerVisibility"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          {/* <Form.Group className="mb-2">
            <Form.Label className="fs-9">Schedule Meeting</Form.Label>
            <div>
              <Button
                as={Link}
                variant="link"
                to="#!"
                // type="button"
                className="badge-subtle-success fw-medium"
                size="sm"
              >
                <FontAwesomeIcon icon="video" className="me-2" />
                <span>Add video conference link</span>
              </Button>
            </div>
          </Form.Group> */}
          <Form.Group className="mb-2" controlId="notes">
            <Form.Label className="fs-9">Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button variant="primary" type="submit" className="px-4 mx-0">
            {loading ? 'Loading...' : 'Publish'}
          </Button>
          <Button
            variant="secondary"
            type="submit"
            className="px-4 mx-2"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

AddScheduleModal.propTypes = {
  setIsOpenScheduleModal: PropTypes.func.isRequired,
  isOpenScheduleModal: PropTypes.bool.isRequired,
  scheduleStartDate: PropTypes.instanceOf(Date),
  setScheduleStartDate: PropTypes.func.isRequired,
  scheduleEndDate: PropTypes.instanceOf(Date),
  setScheduleEndDate: PropTypes.func.isRequired,
  managers: PropTypes.any,
  customers: PropTypes.any,
  nurse: PropTypes.any,
  authToken: PropTypes.any,
  location: PropTypes.any,
  organization: PropTypes.any,
  refresh: PropTypes?.any,
  setRefresh: PropTypes?.any
};

export default AddScheduleModal;
